export const versionLogsData = [
    {
        date: "2026-10-19",
        version: "6.0.14",
        sections: [
            {
                label: "Backend",
                items: [
                    "Les vidéos des médias passent à 200 Mo et les noms de fichiers gardent les accents."
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Les vidéos des médias passent à 200 Mo et les noms de fichiers gardent les accents."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Les vidéos des médias passent à 200 Mo et les noms de fichiers gardent les accents."
                ]
            }
        ]
    },
    {
        date: "2026-10-02",
        version: "6.0.13",
        sections: [
            {
                label: "Backend",
                items: [
                    "Les dossiers, les articles et les contenus pédagogiques gardent un ordre choisi."
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Zoom en consultation, ordre des listes et des médias, cartes plus lisibles."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Les dépôts application pointent vers l’ordre des listes et le zoom.",
                    "Documentation du zoom, de l’ordre des listes et des cartes médias."
                ]
            }
        ]
    },
    {
        date: "2026-09-24",
        version: "6.0.12",
        sections: [
            {
                label: "Backend",
                items: [
                    "Un contenu peut regrouper plusieurs photos, documents et vidéos.",
                    "Le navigateur peut lire la version du serveur après un déploiement."
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Cartes et visionneuse communes pour les médias d’un article ou d’une machine.",
                    "Après un déploiement, l’onglet ouvert charge la nouvelle version tout seul."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Documentation de la galerie mixte des articles et des contenus machines.",
                    "Docs — rechargement automatique après déploiement (version.json)."
                ]
            }
        ]
    },
    {
        date: "2026-09-01",
        version: "6.0.11",
        sections: [
            {
                label: "Frontend",
                items: [
                    "Le déploiement vérifie le site après la page de maintenance, pas pendant."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Page de maintenance pendant les déploiements, sur tous les environnements.",
                    "Docs — DEV et TEST sont en 6.0.10.",
                    "Docs — tag construit 6.0.10 après BUILD_RELEASE."
                ]
            }
        ]
    },
    {
        date: "2026-08-31",
        version: "6.0.10",
        sections: [
            {
                label: "Frontend",
                items: [
                    "Les vignettes des listes se mettent à jour après l’édition d’une photo."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Docs — les vignettes de liste suivent l’édition photo (keep-alive)."
                ]
            }
        ]
    },
    {
        date: "2026-08-29",
        version: "6.0.9",
        sections: [
            {
                label: "Backend",
                items: [
                    "Aligne la fiche de sécurité PDF sur le texte enrichi (12 / 15 / 14 / 13)."
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Éditeur photo — sliders Position, Zoom et Rotation plus précis.",
                    "Merge origin/main into fix/rich-text-type-scale.",
                    "Page publique dossier : couverture au format de cadrage (1/3, sans flou), titre aéré, articles en 16 px.",
                    "Les photos machine et dossier respectent le format de cadrage sur la fiche et la page publique.",
                    "Agrandit le texte enrichi : corps 12, titres 15 / 14 / 13."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Éditeur photo — sliders de cadrage documentés (spec et design system).",
                    "Pointe backend et frontend vers main (texte enrichi et photos publiques).",
                    "Docs — page QR dossier : couverture 1/3 sans flou, titres d’articles 16 px.",
                    "Docs — le cadre photo suit le format de cadrage (anti-régression).",
                    "Documente l’échelle du texte enrichi : 12 / 15 / 14 / 13."
                ]
            }
        ]
    },
    {
        date: "2026-08-29",
        version: "6.0.8",
        sections: [
            {
                label: "Frontend",
                items: [
                    "L’éditeur recharge l’original à la réouverture, pas la photo déjà recadrée."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Docs — l’éditeur recharge l’original à la réédition, pas la photo recadrée."
                ]
            }
        ]
    },
    {
        date: "2026-08-29",
        version: "6.0.7",
        sections: [
            {
                label: "Backend",
                items: [
                    "La fiche de sécurité PDF convertit les photos WebP en JPEG à la génération."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Documente le transcodage WebP → JPEG des photos sur la fiche de sécurité PDF."
                ]
            }
        ]
    },
    {
        date: "2026-08-28",
        version: "6.0.6",
        sections: [
            {
                label: "Backend",
                items: [
                    "Merge origin/main (version 6.0.5) into session tracing.",
                    "Les pages publiques fonctionnent à nouveau : le navigateur a le droit d’envoyer les en-têtes de suivi de session."
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Merge origin/main (version 6.0.5) into session tracing.",
                    "Les fiches publiques (QR) s’affichent sans être bloquées par le suivi de session."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Pointe backend et frontend vers le correctif CORS des pages publiques QR.",
                    "Docs — DEV et TEST sont en 6.0.5 (traçage de session live)."
                ]
            }
        ]
    },
    {
        date: "2026-08-28",
        version: "6.0.5",
        sections: [
            {
                label: "Backend",
                items: [
                    "Connexion — un mot de passe incorrect n’est plus une erreur serveur, et les incidents de session sont journalisés."
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Connexion — la session est tracée et les rechargements en boucle sont arrêtés."
                ]
            },
            {
                label: "Platform",
                items: [
                    "CI/CD — alerte e-mail automatique des incidents de session sur TEST et PROD.",
                    "Arrête automatiquement DEV et TEST après 24 h sans activité CI."
                ]
            }
        ]
    },
    {
        date: "2026-08-25",
        version: "6.0.4",
        sections: [
            {
                label: "Backend",
                items: [
                    "La fiche de sécurité PDF reprend italique, souligné, couleur et aligne les listes sous le texte.",
                    "L’API locale lit la version dans le fichier VERSION du dépôt."
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Le retour depuis une fiche garde la liste au même scroll.",
                    "Réduit la taille du texte enrichi et aligne les retours à la ligne des listes sous le texte.",
                    "Le menu local affiche la version du fichier VERSION du dépôt.",
                    "Le retour depuis une fiche retrouve le scroll et les filtres de la liste."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Pointe le frontend vers le retour liste qui garde le scroll.",
                    "Aligne les sous-modules sur main et range les outils ops réutilisables.",
                    "Aligne docs, specs et TODO sur le live 6.0.3 et le retour liste."
                ]
            }
        ]
    },
    {
        date: "2026-08-24",
        version: "6.0.3",
        sections: [
            {
                label: "Backend",
                items: [
                    "L’API envoie des adresses de médias déjà signées, sans modifier les fichiers ni les clés en base."
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Les documents et médias s’ouvrent via le proxy signé, sans lien S3 direct."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Merge origin/main into signed-media spec commit.",
                    "Documente la lecture des médias via URL signées, sans modifier les clés stockées."
                ]
            }
        ]
    },
    {
        date: "2026-08-24",
        version: "6.0.2",
        sections: [
            {
                label: "Backend",
                items: [
                    "Les PDF d’articles avec espaces dans le nom sont de nouveau lisibles via le proxy."
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Les documents PDF des articles s’ouvrent à nouveau quand le nom de fichier contient des espaces."
                ]
            }
        ]
    },
    {
        date: "2026-08-21",
        version: "6.0.1",
        sections: [
            {
                label: "Frontend",
                items: [
                    "Merge remote-tracking branch 'origin/main' into feature/machine-contenu-pedagogique",
                    "Corrige l’orientation des photos smartphone dans l’éditeur d’images.",
                    "Le bouton Connexion reste visible après expiration de session."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Documente le rendu des consignes : styles PDF, échelle 10/13/12/11 et listes alignées.",
                    "Documente que la version laptop lit VERSION, pas les env live."
                ]
            }
        ]
    },
    {
        date: "2026-08-20",
        version: "6.0.0",
        sections: [
            {
                label: "Backend",
                items: [
                    "Merge remote-tracking branch 'origin/main' into feature/entity-image-phase-3-3-machines",
                    "Ouvre la page publique QR depuis la fiche machine ou dossier."
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Merge remote-tracking branch 'origin/main' into feature/machine-contenu-pedagogique",
                    "Même éditeur de texte et même dépôt de fichier partout (dossiers, articles, machines)."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Documente le texte enrichi unifié, le dépôt de fichier unique et la page publique."
                ]
            }
        ]
    },
    {
        date: "2026-08-20",
        version: "5.1.9",
        sections: [
            {
                label: "Frontend",
                items: [
                    "Le bouton Connexion reste visible après expiration de session."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Documente le texte enrichi des descriptions et les dialogues d’édition responsive.",
                    "Documente le contenu pédagogique machines et le design system unique",
                    "Aligne docs, specs et TODO sur le live 5.1.8 / 5.1.7 et le backlog sécu P1."
                ]
            }
        ]
    },
    {
        date: "2026-08-14",
        version: "5.1.8",
        sections: [
            {
                label: "Frontend",
                items: [
                    "Corrige le chargement de l’image source dans l’éditeur (canvas vide sur AWS)."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Pointe le frontend sur le correctif de chargement image éditeur.",
                    "Aligne la spec éditeur images sur le live 5.1.7 (DEV+TEST).",
                    "Met à jour le statut live : éditeur 5.1.7 sur DEV et TEST."
                ]
            }
        ]
    },
    {
        date: "2026-08-13",
        version: "5.1.7",
        sections: [
            {
                label: "Backend",
                items: [
                    "Réduit la taille Fargate DEV/TEST à 1 vCPU / 2 Go au déploiement."
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Éditeur d’images : couleur de fond personnalisée, pipette et cadrage stable.",
                    "Réduit la taille Fargate DEV/TEST à 1 vCPU / 2 Go au déploiement."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Documente l’éditeur d’images : couleur de fond, pipette et cadrage Options.",
                    "Documente STOP/START validés sur DEV et TEST, et remet le statut live à jour.",
                    "Corrige le YAML STOP/START : quote le check GITLAB_TOKEN (syntaxe :-).",
                    "Corrige l’auth AWS des presets STOP/START (clés terrafrom via GITLAB_TOKEN).",
                    "Ajoute les presets GitLab STOP/START pour DEV et TEST (pause coûts).",
                    "Ajoute les scripts manuels d'arrêt week-end DEV/TEST et la doc d'optimisation coûts."
                ]
            }
        ]
    },
    {
        date: "2026-08-06",
        version: "5.1.6",
        sections: [
            {
                label: "Frontend",
                items: [
                    "Place le bouton Coller à droite de la zone d’upload (2/3–1/3)."
                ]
            }
        ]
    },
    {
        date: "2026-08-06",
        version: "5.1.5",
        sections: [
            {
                label: "Frontend",
                items: [
                    "Garde la flèche retour à gauche du titre sur toutes les fiches détail en mobile.",
                    "Garde la flèche retour à gauche du nom machine en mode mobile.",
                    "Masque les badges statut et type machine quand la valeur est absente."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Documente la convention Design System des en-têtes de fiche (retour liste).",
                    "docs: DEV 5.1.4 — bouton Coller presse-papiers live."
                ]
            }
        ]
    },
    {
        date: "2026-08-05",
        version: "5.1.4",
        sections: [
            {
                label: "Frontend",
                items: [
                    "Ajoute un bouton Coller pour importer une photo depuis le presse-papiers."
                ]
            },
            {
                label: "Platform",
                items: [
                    "docs: DEV 5.1.2 live avec éditeur images machines (3.3)."
                ]
            }
        ]
    },
    {
        date: "2026-08-04",
        version: "5.1.2",
        sections: [
            {
                label: "Backend",
                items: [
                    "Accepte le 409 sur le smoke user-image/source en intégration DEV."
                ]
            }
        ]
    },
    {
        date: "2026-08-04",
        version: "5.1.1",
        sections: [
            {
                label: "Backend",
                items: [
                    "Aligne machine-image sur l’éditeur unifié (crop meta et archive)."
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Éditeur d’images unifié pour les fiches machine."
                ]
            },
            {
                label: "Platform",
                items: [
                    "docs: marque la vague éditeur 3.3 Machines comme code prêt.",
                    "docs: marquer la baseline 5.1.0 avant la vague éditeur 3.3."
                ]
            }
        ]
    },
    {
        date: "2026-08-04",
        version: "5.1.0",
        sections: [
            {
                label: "Platform",
                items: [
                    "docs: realigner statut, roadmap et onboarding agents (5.0.29 live)."
                ]
            }
        ]
    },
    {
        date: "2026-07-24",
        version: "5.0.30",
        features: [
            "Release 5.0.30 — automated CI build (version5.0.30)."
        ]
    },
    {
        date: "2026-07-23",
        version: "5.0.29",
        sections: [
            {
                label: "Backend",
                items: [
                    "Sécurise la création risque/équipement sans fichiers image."
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Retire les photos à la création et ouvre directement la fiche en consultation."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Aligner cdd_root sur version5.0.28 et corriger la résolution de version CI."
                ]
            }
        ]
    },
    {
        date: "2026-07-23",
        version: "5.0.28",
        sections: [
            {
                label: "Backend",
                items: [
                    "Purge les documents legacy au POST/DELETE des images user/risk/equipment.",
                    "Skip les tests d’intégration si TEST_USER_PASSWORD est absent.",
                    "Skip le seed QA si TEST_USER_PASSWORD est absent (pilots feature).",
                    "Assouplit le gate DEV feature : skip check registry cross-projet.",
                    "Corrige le gate de promotion pour les builds feature (JOB-TOKEN).",
                    "Corrige BUILD_DEV : définit APP_VERSION sur les branches feature.",
                    "Expose user_image, risk_image et equipment_image dans list/detail."
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Améliore la fenêtre d’édition d’image : hauteur max, split fixe, zoom/rotation centrés.",
                    "Ajoute des chevrons sur le panneau d’options de l’éditeur d’image.",
                    "Réduit les marges de la fenêtre d’édition d’image.",
                    "Réorganise l’éditeur d’image : canevas sous l’upload, options repliables.",
                    "Corrige le collage à la création risque/équipement et les images cassées en cartes.",
                    "Éditeur d’images : réédition et suppression compatibles avec les documents legacy.",
                    "Assouplit le check registry feature : skip cross-projet sans PAT.",
                    "Corrige le check registry deploy pour les builds feature (JOB-TOKEN).",
                    "Corrige BUILD_DEV : définit APP_VERSION sur les branches feature.",
                    "Éditeur d’images unifié pour utilisateurs, risques et équipements."
                ]
            },
            {
                label: "Platform",
                items: [
                    "docs: coexistence legacy vague 3.2 éditeur images",
                    "docs: marque vague 3.2 éditeur images en cours"
                ]
            }
        ]
    },
    {
        date: "2026-07-17",
        version: "5.0.27",
        sections: [
            {
                label: "Backend",
                items: [
                    "Bloque la migration d'images si des fichiers S3 manquent."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Documente l'écart média TEST et renforce les gates de migration d'images."
                ]
            }
        ]
    },
    {
        date: "2026-07-16",
        version: "5.0.26",
        sections: [
            {
                label: "Frontend",
                items: [
                    "Éditeur d’images : zone de recadrage et export full de taille fixe"
                ]
            },
            {
                label: "Platform",
                items: [
                    "chore: pointeur submodule frontend (crop frame taille fixe)"
                ]
            }
        ]
    },
    {
        date: "2026-07-15",
        version: "5.0.25",
        sections: [
            {
                label: "Frontend",
                items: [
                    "Éditeur d’images : zone d’upload restaurée et forme avant format"
                ]
            },
            {
                label: "Platform",
                items: [
                    "chore: pointeur submodule frontend (upload + ordre forme/format)"
                ]
            }
        ]
    },
    {
        date: "2026-07-15",
        version: "5.0.24",
        sections: [
            {
                label: "Frontend",
                items: [
                    "Recadrage rond : ratio 1:1 forcé et sélecteur de format désactivé"
                ]
            },
            {
                label: "Platform",
                items: [
                    "chore: pointeur submodule frontend (fix crop rond ratio 1:1)"
                ]
            }
        ]
    },
    {
        date: "2026-07-15",
        version: "5.0.23",
        sections: [
            {
                label: "Platform",
                items: [
                    "chore: pointeur submodule frontend (sync version 5.0.22)"
                ]
            }
        ]
    },
    {
        date: "2026-07-14",
        version: "5.0.22",
        sections: [
            {
                label: "Frontend",
                items: [
                    "Correction crash éditeur d’images : ordre de déclaration activeImage"
                ]
            },
            {
                label: "Platform",
                items: [
                    "chore: pointeur submodule frontend (hotfix crash éditeur images)"
                ]
            }
        ]
    },
    {
        date: "2026-07-14",
        version: "5.0.21",
        sections: [
            {
                label: "Frontend",
                items: [
                    "Éditeur d’images : chargement rapide via proxy signé à l’ouverture"
                ]
            },
            {
                label: "Platform",
                items: [
                    "chore: pointeur submodule frontend (chargement rapide éditeur images)"
                ]
            }
        ]
    },
    {
        date: "2026-07-13",
        version: "5.0.20",
        sections: [
            {
                label: "Frontend",
                items: [
                    "Éditeur d’images : preview plus haute et réglages compacts"
                ]
            },
            {
                label: "Platform",
                items: [
                    "chore: pointeur submodule frontend (layout éditeur images)"
                ]
            }
        ]
    },
    {
        date: "2026-07-13",
        version: "5.0.19",
        sections: [
            {
                label: "Backend",
                items: [
                    "Upload photos d’entité : accepter les images WebP"
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Éditeur d’images : zoom arrière, fond coloré, WebP et contrôles de position"
                ]
            },
            {
                label: "Platform",
                items: [
                    "chore: pointeurs submodules frontend/backend (éditeur images zoom/fond/WebP)"
                ]
            }
        ]
    },
    {
        date: "2026-07-13",
        version: "5.0.18",
        sections: [
            {
                label: "Frontend",
                items: [
                    "Éditeur d’images unifié : crop rond, rotation, collage et PNG transparent"
                ]
            },
            {
                label: "Platform",
                items: [
                    "chore: pointeur submodule frontend (éditeur images org Phase 3.1)"
                ]
            }
        ]
    },
    {
        date: "2026-07-10",
        version: "5.0.17",
        sections: [
            {
                label: "Backend",
                items: [
                    "fix(ci): réessayer le registry GitLab sur erreur 429 au promotion gate"
                ]
            },
            {
                label: "Frontend",
                items: [
                    "fix(ci): transmettre les variables pipeline au child build (align version)",
                    "fix(ci): honorer RELEASE_SEMVER_BASE orchestrateur même si VERSION_BUMP=build",
                    "fix(ci): align frontend via registry v2 après docker login",
                    "fix(ci): privilégier RELEASE_SEMVER_BASE passé par l'orchestrateur BUILD",
                    "fix(ci): installer bash dans docker:dind pour l'alignement release",
                    "fix(ci): align registry POSIX + repli common.yml backend si API indisponible",
                    "fix(ci): alignement frontend/backend fiable sur le tag registry le plus récent"
                ]
            },
            {
                label: "Platform",
                items: [
                    "chore: pointeur submodule frontend (forward pipeline_variables build)",
                    "fix(ci): réessayer la création de pipeline frontend sur erreur 429",
                    "fix(ci): forcer VERSION_BUMP=none et retry poll API sur trigger frontend",
                    "fix(ci): trigger frontend BUILD via API pour propager la version alignée",
                    "chore: pointeur submodule frontend (align registry v2)",
                    "fix(ci): charger le dotenv resolve_stack_version avant trigger frontend",
                    "fix(ci): propager la version backend à BUILD_RELEASE frontend via dotenv",
                    "chore: pointeur submodule frontend (bash docker:dind align)",
                    "chore: pointeur submodule frontend (align POSIX + fallback git)",
                    "chore: pointeur submodule frontend (fix align registry BUILD_RELEASE)",
                    "chore: pointeur submodule backend (fix promotion gate 429)",
                    "fix(ops): monitor quitte en --follow quand un pipeline épinglé est terminé"
                ]
            }
        ]
    },
    {
        date: "2026-07-10",
        version: "5.0.6",
        sections: [
            {
                label: "Backend",
                items: [
                    "test(api): attendre *_image dans les specs entités Phase 3.1",
                    "chore: retirer les fichiers __pycache__ du dépôt",
                    "feat(api): inclure *_image actif dans les réponses entités Phase 3.1",
                    "test(ci): Lot D migration — pg_dsn partagé et régressions unittest",
                    "fix(ci): forward pipeline_variables pour migration domain_image",
                    "fix(ci): connexion Prisma DATABASE_URL pour migration domain_image",
                    "fix(ci): ne transmet pas les variables DOMAIN_IMAGE_MIGRATION non définies",
                    "Phase 2 migration domaine : apply/rollback et preset CI DOMAIN_IMAGE_MIGRATION"
                ]
            },
            {
                label: "Frontend",
                items: [
                    "fix(ui): corriger les imports entityImage dans les grilles Phase 3.1",
                    "feat(ui): EntityImageEditor Phase 3.1 — régions à sites via API *-image"
                ]
            },
            {
                label: "Platform",
                items: [
                    "chore: pointeur submodule frontend (fix imports grilles EntityImage)",
                    "chore: pointeur submodule backend (specs *_image Phase 3.1)",
                    "docs: Phase 2 DEV validée et Phase 3.1 EntityImageEditor",
                    "chore: pointeur submodule backend (Lot D migration tests)",
                    "docs(ops): runbook Phase 2 domain_image et gotchas CI migration",
                    "fix(ci): transmettre les variables optionnelles DOMAIN_IMAGE_MIGRATION",
                    "fix(ci): variables optionnelles migration domaine uniquement si définies",
                    "Presets DOMAIN_IMAGE_MIGRATION_{ENV} et orchestrateur phase 2 clone images"
                ]
            }
        ]
    },
    {
        date: "2026-07-09",
        version: "5.0.5",
        sections: [
            {
                label: "Backend",
                items: [
                    "fix(images): conserve key_source lors d'un re-crop sans fichier original",
                    "fix(tests): fixtures JPEG intégration sans Sharp pour la CI ECS"
                ]
            },
            {
                label: "Platform",
                items: [
                    "chore: pointe backend 4a51631 (fix key_source re-crop)",
                    "chore: pointe backend c76f2d0 (fix fixtures intégration)",
                    "chore: pointe backend après fix fixtures intégration domain-image"
                ]
            }
        ]
    },
    {
        date: "2026-07-09",
        version: "5.0.4",
        sections: [
            {
                label: "Backend",
                items: [
                    "fix(build): corrige le conflit de nom TypeScript sur DomainImageControllerHost",
                    "Phase 1 éditeur images unifié : endpoints *-image et schéma canonique par domaine"
                ]
            },
            {
                label: "Platform",
                items: [
                    "chore: pointe backend après fix build DomainImageControllerHost",
                    "Spec éditeur images unifié (phase 1) et pointeur backend"
                ]
            }
        ]
    },
    {
        date: "2026-07-09",
        version: "5.0.3",
        features: [
            "Release 5.0.3 — automated CI build (version5.0.3)."
        ]
    },
    {
        date: "2026-07-09",
        version: "5.0.2",
        sections: [
            {
                label: "Backend",
                items: [
                    "chore: ignore scripts/ci __pycache__",
                    "fix(image-proxy): dérive l'URL API depuis FRONTEND_URL si besoin",
                    "fix(tests): restaure les imports helpers dans global-setup",
                    "fix(tests): imports fs compatibles avec globalSetup Jest en CI",
                    "fix(tests): globalSetup QA token pour éviter le throttle signin en CI",
                    "fix(tests): réutilise un token QA en intégration pour éviter le throttle signin"
                ]
            },
            {
                label: "Platform",
                items: [
                    "chore: pointe backend image-proxy FRONTEND_URL fallback + tests intégration",
                    "chore: pointe backend après fix import global-setup",
                    "chore: pointe backend après fix globalSetup fs",
                    "chore: pointe backend après correctif tests intégration throttle",
                    "docs: précise le token QA partagé pour les tests d'intégration P1"
                ]
            }
        ]
    },
    {
        date: "2026-07-09",
        version: "5.0.1",
        sections: [
            {
                label: "Backend",
                items: [
                    "Tests P1 : couverture auth, proxy signé, IDOR et intégration DEV",
                    "Sécurisation P1 : throttle auth, IDOR utilisateurs, proxy signé et policies documents"
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Tests P1 : cache proxy signé, intercepteurs et pages QR publiques",
                    "Médias : URLs proxy signées avec renouvellement silencieux (Sprint B)"
                ]
            },
            {
                label: "Platform",
                items: [
                    "Docs : carte des tests Sprint A/B sécurité P1",
                    "chore: pointe les submodules backend et frontend après Sprint B sécurité",
                    "Docs 5.0.0 : plan sécurité P1, specs proxy public et alignement backlog"
                ]
            }
        ]
    },
    {
        date: "2026-07-08",
        version: "5.0.0",
        sections: [
            {
                label: "Backend",
                items: [
                    "fix(ci): forward VERSION_BUMP vers le child pipeline build"
                ]
            },
            {
                label: "Platform",
                items: [
                    "fix(ci): passer VERSION_BUMP explicitement au trigger backend (sans extends)"
                ]
            }
        ]
    },
    {
        date: "2026-07-08",
        version: "4.15.61",
        sections: [
            {
                label: "Platform",
                items: [
                    "fix(ci): forward pipeline_variables vers le build backend (VERSION_BUMP major)"
                ]
            }
        ]
    },
    {
        date: "2026-07-08",
        version: "4.15.60",
        sections: [
            {
                label: "Platform",
                items: [
                    "fix(ci): transmettre VERSION_BUMP au build backend sur BUILD_RELEASE"
                ]
            }
        ]
    },
    {
        date: "2026-07-08",
        version: "4.15.59",
        sections: [
            {
                label: "Backend",
                items: [
                    "fix(migration): limite apply après déduplication et commit par machine"
                ]
            }
        ]
    },
    {
        date: "2026-07-08",
        version: "4.15.58",
        sections: [
            {
                label: "Backend",
                items: [
                    "fix(migration): orientation EXIF, hard delete rollback et verify orientation",
                    "fix(migration): dérivés depuis variantes cropped legacy (sans EXIF sur original)",
                    "fix(migration): dérivés depuis le cropped S3 legacy (orientation correcte)",
                    "fix(migration): legacy DB sans S3 en warning verify non bloquant",
                    "fix(ci): isolation des presets V2 — pas de forensics pendant migration",
                    "fix(ci): ne pas lancer forensics backup sur chaque pipeline backend",
                    "fix(ci): transmettre FORENSICS_BACKUP_V2 à la tâche ECS forensics",
                    "fix(ci): corriger include pipeline backup forensics",
                    "fix(migration): sources S3 vides en verify_ok_no_photo (alignement audit)",
                    "feat(ci): backup forensics RDS isolé de la PROD live",
                    "fix(migration): MIGRATION_LIMIT exclut les machines déjà migrées",
                    "fix(ci): boucle de polling ECS compatible awscli GitLab",
                    "fix(migration): appliquer EXIF avant recadrage et mode rollback machine_image",
                    "fix(ci): skip soft-deleted machines in machine_image migration audit/verify",
                    "fix(migration): skip already-migrated machines on apply re-run."
                ]
            },
            {
                label: "Frontend",
                items: [
                    "fix(machines): réduire le flicker du fond flou au survol de la photo"
                ]
            },
            {
                label: "Platform",
                items: [
                    "chore(frontend): sync submodule — fix flicker fond flou photo machine",
                    "docs(ops): algorithme orientation machine_image et rollback hard delete",
                    "docs(ops): préciser variantes cropped legacy et crop sans EXIF",
                    "docs(ops): migration machine_image — dérivés depuis cropped S3 legacy"
                ]
            }
        ]
    },
    {
        date: "2026-07-06",
        version: "4.15.57",
        sections: [
            {
                label: "Backend",
                items: [
                    "fix(tests): align specs with machine_image cutover; verify legacy keys.",
                    "fix(ci): verify skips unreadable legacy sources like apply does.",
                    "fix(ci): pip install with --break-system-packages on Debian bookworm.",
                    "fix(ci): install pip3 in ECS before migration Python deps.",
                    "fix(ci): use repo-relative path for ECS migration delegation.",
                    "feat(machine_image): new photo model, S3 migration job, and API cutover.",
                    "fix(ci): forward pipeline vars for backfill instead of empty expansions.",
                    "fix(ci): forward BACKFILL dry-run and limit vars to backfill child.",
                    "feat(ci): backfill original machine_document rows in single pass.",
                    "feat(ci): add audit-deep mode for machine document variant checks."
                ]
            },
            {
                label: "Frontend",
                items: [
                    "feat(machines): read and write photos via machine_image keys."
                ]
            },
            {
                label: "Platform",
                items: [
                    "feat(ci): MACHINE_IMAGE_MIGRATION presets replace legacy backfill.",
                    "feat(monitor): fade 12h, finished-since, direct watch and full operator spec",
                    "fix(ci): forward pipeline vars on backfill cross-project bridge.",
                    "fix(ci): forward backfill dry-run/limit through orchestrator bridge.",
                    "docs: backfill default scope all includes original machine photos.",
                    "docs(ci): document audit-deep backfill mode on orchestrator."
                ]
            }
        ]
    },
    {
        date: "2026-07-04",
        version: "4.15.56",
        sections: [
            {
                label: "Backend",
                items: [
                    "fix(ci): stabilize BACKFILL_V2 cross-project trigger.",
                    "Separate BACKFILL_V2 pipeline from deploy chain.",
                    "fix(ci): deps Python backfill via apt dans tâche ECS (sans pip)",
                    "fix(ci): stage backfill après check-migrate + forward variables DEPLOY",
                    "ci(ops): audit/backfill vignettes machine_document en DEPLOY (RDS privé)",
                    "fix(deploy): résoudre APP_RUNTIME_SECRET_ARN automatiquement si variable GitLab absente",
                    "Fix intégration ECS : skip health-check runner et curl dans bootstrap",
                    "Ops DB : tests intégration DEV via ECS Fargate (Prisma + RDS privé)",
                    "Ops DB : seed QA via ECS Fargate et vars TEST_USER en tâche",
                    "Ops DB : migrate Prisma via ECS Fargate (RDS privé)"
                ]
            },
            {
                label: "Platform",
                items: [
                    "fix(ci): pass minimal vars on backfill cross-project bridge.",
                    "fix(ci): simplify BACKFILL orchestrator trigger variable forwarding.",
                    "Add BACKFILL_BACKEND_* orchestrator presets separate from deploy.",
                    "feat(ops): monitor direct module pipelines detached from orchestrator",
                    "feat(ci): preset DEPLOY_BACKEND_TEST (backend-only sur TEST)",
                    "fix(ci): forward variables backfill vers backend DEPLOY_BACKEND_DEV",
                    "docs(ops): backfill vignettes machines via CI DEPLOY (RDS privé)",
                    "Unification doc sécurité post-P0 : audit, TODO et plan release 4.16.x",
                    "docs(ops): troubleshooting APP_RUNTIME_SECRET_ARN et bump backend deploy fix",
                    "Doc intégration ECS et fix script configure APP_RUNTIME_SECRET_ARN"
                ]
            }
        ]
    },
    {
        date: "2026-07-02",
        version: "4.15.55",
        sections: [
            {
                label: "Backend",
                items: [
                    "Fix ops DB ECS : entryPoint dans task definition (aligné terrafrom)",
                    "Fix ops DB ECS : root + entrypoint bash (aligné terrafrom)",
                    "Fix ops DB ECS : export CONTAINER_NAME (aligné terrafrom)",
                    "Fix ops DB ECS : logs S3 sans CloudWatch (aligné terrafrom)",
                    "Ops DB : backup via tâche ECS Fargate (RDS privé)"
                ]
            },
            {
                label: "Platform",
                items: [
                    "Doc ops DB ECS : logs S3 et troubleshooting CloudWatch",
                    "Doc ops DB VPC/ECS et pointeurs submodules restore sécurisé"
                ]
            },
            {
                label: "Infrastructure",
                items: [
                    "PROVISION : force le restore DB après apply (écrase données résiduelles)",
                    "Fix ops DB ECS : entryPoint dans task definition uniquement",
                    "Fix ops DB ECS : root + entrypoint bash (image postgres)",
                    "Fix ops DB ECS : export CONTAINER_NAME avant enregistrement task",
                    "Fix ops DB ECS : logs S3 sans CloudWatch (execution role)",
                    "Ops DB : restore et verify via tâche ECS Fargate (RDS privé)"
                ]
            }
        ]
    },
    {
        date: "2026-07-01",
        version: "4.15.54",
        sections: [
            {
                label: "Backend",
                items: [
                    "Sécurité P0 : guards site-pole-metier et uploads S3 privés",
                    "Tests renforcés périmètre régional et génération PDF sans skip",
                    "fix(ci): stabiliser check-deploy après rollout ECS (DEV/TEST/PROD)"
                ]
            },
            {
                label: "Frontend",
                items: [
                    "fix(app): éviter shell cassé pendant indisponibilité backend au déploiement",
                    "Menu latéral à jour après changement de droits du rôle",
                    "fix(ci): attendre fin de rollout ECS et HTTP stable avant check-deploy",
                    "fix(app): garde-fous mobile iOS/Android pour la résilience navigateur"
                ]
            },
            {
                label: "Platform",
                items: [
                    "Pointeur backend après correctifs P0 sécurité",
                    "Doc runbook P0 sécurité et suivi audit C1-C4",
                    "docs: shell dashboard bloqué pendant déploiement — spec résilience v1.1",
                    "fix(ci): doc et bump submodules — check-deploy stable après rollout ECS",
                    "docs: résilience navigateur v1.1 — guide client, dev et agent IA",
                    "feat(ops): boot screen, desktop alerts and sounds for pipeline monitor",
                    "feat(ops): resilient GitLab pipeline monitor with network recovery"
                ]
            },
            {
                label: "Infrastructure",
                items: [
                    "P0 security: private RDS, S3 block public access, ECS Secrets Manager"
                ]
            }
        ]
    },
    {
        date: "2026-07-01",
        version: "4.15.53",
        features: [
            "Release 4.15.53 — automated CI build (version4.15.53)."
        ]
    },
    {
        date: "2026-07-01",
        version: "4.15.52",
        sections: [
            {
                label: "Backend",
                items: [
                    "Pickers région/site pour gestionnaires : liste complète et tests"
                ]
            },
            {
                label: "Frontend",
                items: [
                    "feat(app): résilience session, serveur inaccessible et reload version",
                    "fix(app): reload automatique quand une nouvelle version est déployée",
                    "Affichage sélecteur régions pour gestionnaires avec une seule région"
                ]
            },
            {
                label: "Platform",
                items: [
                    "docs: spécification résilience navigateur (session, deploy, version)",
                    "Spec périmètre régional utilisateurs et doc pickers région/site"
                ]
            }
        ]
    },
    {
        date: "2026-07-01",
        version: "4.15.51",
        sections: [
            {
                label: "Backend",
                items: [
                    "fix(test): échec explicite si le périmètre régional user n'est pas déployé",
                    "Tests d'intégration DEV : périmètre régional utilisateurs",
                    "Tests périmètre régional utilisateurs : unitaires et endpoints",
                    "Validation affectation régions/sites à la création et modification utilisateur",
                    "Liste utilisateurs limitée au périmètre régional du connecté",
                    "Suppression du flag is_admin inutilisé sur le modèle user",
                    "fix(machine): correct electrical field units and rename intensity label"
                ]
            },
            {
                label: "Frontend",
                items: [
                    "fix(machine): correct electrical field units and rename intensity label"
                ]
            },
            {
                label: "Platform",
                items: [
                    "docs(test): inventaire des skips et exigence deploy pour intégration user-regional",
                    "Documentation RBAC et cohérence des specs/tests"
                ]
            }
        ]
    },
    {
        date: "2026-06-28",
        version: "4.15.50",
        sections: [
            {
                label: "Backend",
                items: [
                    "Correction des tests unitaires pour vignettes S3 et clés structurées",
                    "Photos et documents — vignettes S3, limites 10 Mo et clés structurées"
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Upload photos jusqu'à 10 Mo, vignettes et lecture médias via proxy backend"
                ]
            },
            {
                label: "Platform",
                items: [
                    "Spec transversale médias S3 et documentation agents",
                    "Documentation — rebuild du changelog Release Updates et restauration historique"
                ]
            }
        ]
    },
    {
        date: "2026-06-27",
        version: "4.15.49",
        sections: [
            {
                label: "Frontend",
                items: [
                    "Fiche publique machine — masquer les champs et sections vides"
                ]
            },
            {
                label: "Platform",
                items: [
                    "Specs fiche machine — masquage des contenus vides sur la fiche publique QR"
                ]
            }
        ]
    },
    {
        date: "2026-06-27",
        version: "4.15.48",
        sections: [
            {
                label: "Frontend",
                items: [
                    "Alignement du dialogue évaluation d'utilisation sur la convention pied de dialogue"
                ]
            },
            {
                label: "Platform",
                items: [
                    "Specs — convention UI pied de dialogue transversale (tous modules)"
                ]
            }
        ]
    },
    {
        date: "2026-06-26",
        version: "4.15.47",
        sections: [
            {
                label: "Backend",
                items: [
                    "Ajout du lien d'évaluation d'utilisation sur la fiche machine"
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Évaluation d'utilisation — lien Google Form sur la fiche machine et fiche publique QR",
                    "Correction du défilement du preview PDF et du menu latéral sur mobile"
                ]
            },
            {
                label: "Platform",
                items: [
                    "Specs fiche machine — évaluation d'utilisation et index module Machines"
                ]
            }
        ]
    },
    {
        date: "2026-06-26",
        version: "4.15.46",
        sections: [
            {
                label: "Backend",
                items: [
                    "fix(pdf): larger picto grids and SST/referent blocks on security sheet",
                    "Fiche de sécurité — pied de page deux colonnes, libellés et grilles de pictogrammes alignées à gauche."
                ]
            }
        ]
    },
    {
        date: "2026-06-26",
        version: "4.15.45",
        sections: [
            {
                label: "Backend",
                items: [
                    "Documentation — politique des messages de commit pour le changelog Release Updates (section Backend)."
                ]
            },
            {
                label: "Frontend",
                items: [
                    "Release Updates — reconstruction du changelog historique groupé par zone.",
                    "Release Updates — changelog groupé par zone du projet (Backend, Frontend, Platform, Infrastructure)."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Platform — pointeur frontend pour changelog Release Updates reconstruit.",
                    "Documentation — politique commit messages et changelog Release Updates multi-repos.",
                    "Opérations — Parallel pipeline watch and readable CI quota in monitor",
                    "Opérations — export/import de données PROD vers TEST.",
                    "Opérations — Speed up PROD export with bulk s3 sync"
                ]
            },
            {
                label: "Infrastructure",
                items: [
                    "Documentation — politique des messages de commit pour le changelog Release Updates (section Infrastructure)."
                ]
            }
        ]
    },
    {
        date: "2026-06-26",
        version: "4.15.44",
        sections: [
            {
                label: "Backend",
                items: [
                    "Fiche de sécurité — pictogrammes centrés, texte agrandi et mise en page affinée."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Fiche de sécurité PDF — spécification v1.1 et feuille de route modèles.",
                    "Documentation — fiche sécurité PDF et comptes QA.",
                    "Opérations — suivi des pipelines CI en temps réel."
                ]
            }
        ]
    },
    {
        date: "2026-06-26",
        version: "4.15.43",
        sections: [
            {
                label: "Backend",
                items: [
                    "Fiche de sécurité — en-tête, grilles et zone de consignes de sécurité affinés.",
                    "Fiche de sécurité — pied de page deux colonnes, libellés et grilles de pictogrammes alignées à gauche."
                ]
            },
            {
                label: "Platform",
                items: [
                    "Opérations — export/import de données PROD vers TEST."
                ]
            }
        ]
    },
    {
        date: "2026-06-26",
        version: "4.15.42",
        sections: [
            {
                label: "Backend",
                items: [
                    "Fiche de sécurité — logo, QR code, pied de page et photo machine sur la fiche."
                ]
            }
        ]
    },
    {
        date: "2026-06-26",
        version: "4.15.41",
        sections: [
            {
                label: "Backend",
                items: [
                    "Fiche de sécurité — refonte en affiche A3 une page."
                ]
            }
        ]
    },
    {
        date: "2026-06-25",
        version: "4.15.40",
        sections: [
            {
                label: "Platform",
                items: [
                    "Documentation — revue de cohérence CI/CD et spécifications.",
                    "Release Updates — synchronisation automatique du changelog."
                ]
            },
            {
                label: "Application",
                items: [
                    "CI — publication de version compatible bash (scripts POSIX)."
                ]
            }
        ]
    },
    {
        date: "2026-06-23",
        version: "4.15.38",
        sections: [
            {
                label: "Platform",
                items: [
                    "Release Updates — synchronisation automatique du changelog."
                ]
            }
        ]
    },
    {
        date: "2026-06-23",
        version: "4.15.37",
        sections: [
            {
                label: "Backend",
                items: [
                    "API — endpoint de contrôle de santé JSON et garde-fou HTTP CI.",
                    "CI — tests unitaires bloquants après validation des déploiements DEV.",
                    "CI — exécution des tests Jest avant build Docker.",
                    "Articles — Allow video replacement on article update",
                    "Export QR PDF — vignette ratio et QR visible",
                    "Articles — MVP médias multi-types, statuts et permissions dossier"
                ]
            },
            {
                label: "Application",
                items: [
                    "CI/CD — BUILD_RELEASE puis DEPLOY_* (build once, promote DEV→TEST→PROD).",
                    "Presets orchestrateur via menu spec:inputs et trigger_preset.sh.",
                    "Articles — lecteurs médias unifiés, galerie photos, statuts et permissions dossier.",
                    "Correctifs CI gates (registry, promotion) et sync version automatique."
                ]
            }
        ]
    },
    {
        date: "2026-05-21",
        version: "4.14.0",
        sections: [
            {
                label: "Application",
                items: [
                    "Release 4.14.0 — version affichée synchronisée avec le tag Docker (APP_VERSION injecté au build CI).",
                    "Corrections restore DB, vérification post-restore et cycles destroy→deploy GitLab UI."
                ]
            }
        ]
    },
    {
        date: "2026-06-08",
        version: "4.12.2",
        sections: [
            {
                label: "Application",
                items: [
                    "Release 4.12.2 — full TEST deploy from GitLab UI with DEPLOY_TEST=true (automatic job chain).",
                    "Validates CI/CD pipeline without API scripts after migrate needs fix."
                ]
            }
        ]
    },
    {
        date: "2026-06-08",
        version: "4.12.1",
        sections: [
            {
                label: "Application",
                items: [
                    "Release 4.12.1 — TEST environment cleanup and full redeploy via GitLab CI.",
                    "GitLab UI pipeline workflow with needs chains and terraform CI variables."
                ]
            }
        ]
    },
    {
        date: "2026-06-08",
        version: "4.12.0",
        sections: [
            {
                label: "Application",
                items: [
                    "Release 4.12.0 — CI/CD entièrement basé sur le service account GitLab cdd-cicd-sa.",
                    "Validation complète doc, scripts et déploiement TEST automatisé."
                ]
            }
        ]
    },
    {
        date: "2026-06-08",
        version: "4.11.0",
        sections: [
            {
                label: "Application",
                items: [
                    "Release de validation TEST — mise à jour CI/CD (service account cdd-cicd-sa) et déploiement infrastructure."
                ]
            }
        ]
    },
    {
        date: "2026-06-07",
        version: "4.10.0",
        sections: [
            {
                label: "Application",
                items: [
                    "Mise à jour de l’export PDF de la fiche de sécurité pour un meilleur affichage et un meilleur positionnement.",
                    "Ajout de la possibilité d’ajouter des vidéos et des fichiers PDF aux dossiers d’articles.",
                    "Correction de l’affichage des pictogrammes du code QR des machines pour les équipements et les risques."
                ]
            }
        ]
    },
    {
        date: "2026-04-11",
        version: "4.9.0",
        sections: [
            {
                label: "Application",
                items: [
                    "Augmentation de la limite de taille des images téléchargeables pour les fichiers et les articles.",
                    "Mise à jour de l’export PDF de la fiche de sécurité pour un meilleur affichage et un meilleur positionnement."
                ]
            }
        ]
    },
    {
        date: "2025-10-18",
        version: "4.8.0",
        sections: [
            {
                label: "Application",
                items: [
                    "Introduction de fonctionnalités complètes de gestion (CRUD) pour les dossiers d’articles.",
                    "Mise en place d’opérations CRUD complètes pour les articles, offrant la possibilité de créer, modifier, consulter et supprimer des articles en toute simplicité.",
                    "Refonte de l’interface de la page de consultation à rôle unique pour une expérience plus claire et intuitive.",
                    "Optimisation de la fonctionnalité d’export des fiches de sécurité machines (PDF) pour une génération de documents plus précise et professionnelle.",
                    "Optimisation de l’affichage et de l’accès aux données du tableau de bord pour des analyses plus rapides et une meilleure ergonomie.",
                    "Amélioration de la gestion des photos, avec des modifications et une organisation des images facilitées."
                ]
            }
        ]
    },
    {
        date: "2025-10-12",
        version: "4.7.0",
        sections: [
            {
                label: "Application",
                items: [
                    "Amélioration de l'affichage et de la gestion des permissions de rôles.",
                    "Ajout d'un système complet de gestion des identifiants pour les Tableaux financiés.",
                    "Ajout du nouveau module 'Machines archivées' avec contrôle d'accès basé sur les identifiants.",
                    "Ajout de la fonctionnalité d'export PDF pour la 'Fiche de Sécurité' dans la page de détails de la machine.",
                    "Optimisation des requêtes de données des sites pour améliorer les performances et réduire les temps de chargement.",
                    "Ajout d'un module par défaut configurable pour la personnalisation du tableau de bord générique.",
                    "Séparation des dépenses de factures du prix des machines dans les tableaux de bord financiers pour une meilleure analyse des coûts."
                ]
            }
        ]
    },
    {
        date: "2025-10-07",
        version: "4.6.0",
        sections: [
            {
                label: "Application",
                items: [
                    "Ajout de l'action d'exportation pour le PDF 'Fiche de Sécurité' dans la page de détails de la machine.",
                    "Ajout de la fonction de recadrage d’image, les utilisateurs peuvent désormais sélectionner et recadrer une partie spécifique d’une image avant de la télécharger. Cette amélioration s’applique aux modules Utilisateurs, Risques et Équipements."
                ]
            }
        ]
    },
    {
        date: "2025-10-06",
        version: "4.5.0",
        sections: [
            {
                label: "Application",
                items: [
                    "Amélioration de la gestion des images dans les modules Machines, Utilisateurs, Risques et Équipements avec un redimensionnement automatique à l’import, la génération de miniatures pour des aperçus cohérents et une normalisation des dimensions afin d’optimiser les performances, le stockage et la cohérence visuelle.",
                    "Des améliorations générales et corrections de bugs ont été apportées à l'application afin d’améliorer la stabilité, d’optimiser les performances et de garantir une expérience utilisateur plus fluide et fiable."
                ]
            }
        ]
    },
    {
        date: "2025-09-29",
        version: "4.4.0",
        sections: [
            {
                label: "Application",
                items: [
                    "Ajout d’un nouveau module CRUD pour gérer la liste des Risques.",
                    "Ajout d’un nouveau module CRUD pour gérer la liste des Équipements.",
                    "Suppression du système de gestion des numéros de téléphone internationaux, car la plupart des numéros utilisés sont en France.",
                    "Extension des informations du site avec les champs supplémentaires suivants: Rue, Rue 2, Numéro Tel Prévot and Numéro Tel Accueil",
                    "Ajout d’un nouvel onglet dans le tableau de bord permettant de comparer les dépenses des sites entre l’année en cours et l’année précédente.",
                    "Correction d’un problème où la mise à jour des données utilisateur (nom, email, rôle, etc.) n’était pas correctement enregistrée dans certains cas. Cette correction garantit que toutes les modifications apportées aux profils utilisateurs sont bien prises en compte et visibles dans l’ensemble du système.",
                    "Ajout d'une nouvelle action 'Ouvrir le document' qui affiche un aperçu du document dans une pop-in (fenêtre modale) pour tous les types de documents. Cela permet aux utilisateurs de prévisualiser rapidement les documents directement dans l’application, sans avoir à les télécharger ni à les ouvrir dans un nouvel onglet. Une amélioration notable pour la fluidité du travail."
                ]
            }
        ]
    },
    {
        date: "2025-09-18",
        version: "4.3.0",
        sections: [
            {
                label: "Application",
                items: [
                    "Plusieurs améliorations de performance, ajustements mineurs de l’interface et corrections de bugs ont été apportés à l’ensemble de l’application afin d’assurer une expérience utilisateur plus fluide et plus stable."
                ]
            }
        ]
    },
    {
        date: "2025-09-09",
        version: "4.2.0",
        sections: [
            {
                label: "Application",
                items: [
                    "Ajout d’un nouveau tableau financier pour les dépenses de site. Ce tableau permet aux utilisateurs de suivre, gérer et analyser les dépenses liées à des sites ou emplacements spécifiques.",
                    "L’application mémorise désormais vos préférences de tri et de filtrage pour chaque écran. Lors du rafraîchissement de la page ou lors d’un retour ultérieur, les filtres et l’ordre de tri précédemment sélectionnés seront automatiquement réappliqués, offrant ainsi une expérience plus fluide et personnalisée.",
                    "Amélioration de la mise en page du PDF d’export des machines avec un design plus clair et structuré. Le PDF exporté inclut désormais l’image de la machine, offrant un meilleur aperçu visuel et un format de document plus professionnel à partager.",
                    "Mise à jour du formulaire de remarque anonyme : le champ email est désormais facultatif. Les utilisateurs peuvent soumettre une remarque sans fournir leur adresse email, ce qui améliore la confidentialité tout en laissant la possibilité d’être recontacté s’ils le souhaitent.",
                    "La page QR Code de la machine affiche désormais la Codification Interne de la machine. Cela permet aux utilisateurs d’identifier plus facilement les machines sur site grâce à cette référence interne unique, en complément des autres informations clés."
                ]
            }
        ]
    },
    {
        date: "2025-09-04",
        version: "4.1.0",
        sections: [
            {
                label: "Application",
                items: [
                    "Ajout de filtres par année et par mois dans le tableau financier, permettant aux utilisateurs de filtrer les données financières par période spécifique. Cette amélioration facilite l’analyse rapide et le suivi des dépenses et revenus au fil du temps.",
                    "Dans le tableau financier, les améliorations suivantes ont été apportées : - Remplacement des valeurs N/A dans la colonne Dépenses par 0 pour plus de cohérence. - Amélioration du format des nombres pour une meilleure lisibilité (ex. : séparateur de milliers, nombre fixe de décimales).",
                    "Application du système de design aux filtres de tous les tableaux de l’application. Cela garantit une expérience utilisateur cohérente, améliore la lisibilité visuelle et aligne les composants de filtrage avec l’identité graphique globale de la plateforme.",
                    "Il est désormais possible d’imprimer un QR Code pour chaque machine, pointant vers une URL publique secrète en lecture seule. Toute personne scannant le code peut consulter les informations de la machine sans authentification, tout en garantissant la sécurité des données en lecture seule.",
                    "Amélioration de la page publique en lecture seule des machines accessible via QR Code pour permettre l’ajout d’informations. Les utilisateurs accédant à cette URL secrète peuvent désormais soumettre des informations ou des notes supplémentaires à la machine — sans avoir accès à la modification des données existantes."
                ]
            }
        ]
    },
    {
        date: "2025-08-25",
        version: "4.0.4",
        sections: [
            {
                label: "Application",
                items: [
                    "Correction d'un bug lors du filtrage des machines par remarque",
                    "Ajout d'un champ obligatoire 'Raison d'archivage' lors de l'archivage d'une machine",
                    "Amélioration de la suppression des remarques : seuls les utilisateurs ayant les droits appropriés et ayant créé la remarque peuvent la supprimer, et seulement si leur compte est encore actif",
                    "Ajout du tri pour la liste des machines par pourcentage de maintenance",
                    "Développement de la première version du tableau de bord financier"
                ]
            }
        ]
    },
    {
        date: "2025-08-23",
        version: "4.0.3",
        sections: [
            {
                label: "Application",
                items: [
                    "Ajout d’un nouveau module de rapports des machines. Ce module permet aux utilisateurs de créer, gérer et consulter des rapports détaillés liés à chaque machine",
                    "Ajout de la possibilité d’archiver les machines. Les utilisateurs peuvent désormais archiver ou désarchiver une machine, ce qui permet de maintenir une liste de machines actives plus claire et organisée.",
                    "Dans la page Détails de la machine, vous pouvez désormais voir tous les contacts de l’entreprise liés à cette machine. Cela permet d’identifier rapidement et de contacter facilement la bonne personne (technique, administrative ou maintenance) directement depuis la fiche machine."
                ]
            }
        ]
    },
    {
        date: "2025-08-17",
        version: "4.0.2",
        sections: [
            {
                label: "Application",
                items: [
                    "Ajout de la gestion complète des rapports de contrôle des machines. Les utilisateurs peuvent désormais créer, consulter, mettre à jour et gérer les rapports de contrôle associés à chaque machine."
                ]
            }
        ]
    },
    {
        date: "2025-08-07",
        version: "4.0.1",
        sections: [
            {
                label: "Application",
                items: [
                    "Il est désormais possible de créer une note de type (Sécurité, Information, Maintenance, etc.) et de l’attacher à toute machine à laquelle vous avez un accès en lecture. Cela permet à tout utilisateur de partager des notes importantes avec les gestionnaires et d’améliorer la communication au sein de l’équipe.",
                    "Un problème a été résolu où les identifiants étaient affichés par erreur lors de la création ou modification d’un rôle. Cette correction améliore la sécurité et garantit que les données sensibles restent masquées pendant la gestion des rôles.",
                    "La fonction de recherche dans l’écran de la liste des machines a été étendue. Il est désormais possible de rechercher en utilisant les champs suivants : Modèle, Numéro de Série, Codification Interne et Puissance électrique, Cela permet de trouver plus facilement une machine grâce à des critères plus précis.",
                    "Les informations de maintenance des machines sont désormais affichées automatiquement à partir du contrat associé. Cela améliore la visibilité sur les services prévus et garantit la conformité avec les termes du contrat."
                ]
            }
        ]
    },
    {
        date: "2025-07-28",
        version: "4.0.0",
        sections: [
            {
                label: "Application",
                items: [
                    "Mémorisation automatique du mode d'affichage préféré (carte ou tableau) pour chaque utilisateur et chaque écran de liste (Machines, Utilisateurs, etc.)",
                    "Simplification de la sélection de sites sans nécessité de sélectionner un pôle lors du filtrage des machines en mode carte",
                    "Possibilité de modifier l'adresse email d'un utilisateur depuis le module de gestion des utilisateurs",
                    "Nouveau module de gestion des documents de marques avec fonctionnalités complètes (création, lecture, modification, suppression)",
                    "Nouveau module de gestion des documents de métiers avec fonctionnalités complètes (création, lecture, modification, suppression)",
                    "Nouveau module de gestion des documents de régions avec fonctionnalités complètes (création, lecture, modification, suppression)",
                    "Module complet de gestion des marques avec toutes les opérations CRUD disponibles",
                    "Module complet de gestion des métiers avec toutes les opérations CRUD disponibles",
                    "Module complet de gestion des régions avec toutes les opérations CRUD disponibles",
                    "Mise en place du module de gestion des sites avec fonctionnalités complètes (création, lecture, modification, suppression)",
                    "Export des listes filtrées au format Excel et PDF pour les fiches machines"
                ]
            }
        ]
    },
    {
        date: "2025-06-12",
        version: "3.0.3",
        sections: [
            {
                label: "Application",
                items: [
                    "Un nouveau filtre de date permet aux utilisateurs de trier et de consulter facilement les contrats et les factures selon des périodes spécifiques.",
                    "Nous introduisons une fonctionnalité intuitive de glisser-déposer pour le téléchargement de documents dans les contrats et les factures, améliorant ainsi l'expérience utilisateur et l'efficacité."
                ]
            }
        ]
    },
    {
        date: "2025-06-05",
        version: "3.0.2",
        sections: [
            {
                label: "Application",
                items: [
                    "Cette version contient des corrections de bugs et quelques améliorations."
                ]
            }
        ]
    },
    {
        date: "2025-05-28",
        version: "3.0.1",
        sections: [
            {
                label: "Application",
                items: [
                    "Corriger le bug du champ de sélection \"créable\" pour les entreprises, car des doublons sont créés par erreur.",
                    "Corriger le bug du modification du nombre de visites lors de la création d’un contrat.",
                    "Ajouter la possibilité d’associer une machine à un contrat ou à une facture depuis la page de la machine.",
                    "Lors de la création d'une nouvelle facture, rediriger automatiquement vers la page d'édition.",
                    "Afficher le numéro de facture complet au lieu d’abréger avec \"k\" comme unité.",
                    "Déplacer la colonne \"Numéro de contrat\" à la fin de la liste des contrats.",
                    "Changer le format d’affichage de la date en jj/mm/aaaa."
                ]
            }
        ]
    },
    {
        date: "2025-05-09",
        version: "3.0.0",
        sections: [
            {
                label: "Application",
                items: [
                    "Implémenter les opérations CRUD (Créer, Lire, Mettre à jour, Supprimer) pour les contrats.",
                    "Implémenter les opérations CRUD (Créer, Lire, Mettre à jour, Supprimer) pour les factures.",
                    "Ajouter les sections contrats de maintenance et factures à la page de détails de la machine."
                ]
            }
        ]
    },
    {
        date: "2025-03-16",
        version: "2.0.3",
        sections: [
            {
                label: "Application",
                items: [
                    "Implémentation d'un système avancé de suivi des erreurs pour améliorer la surveillance et le dépannage du système."
                ]
            }
        ]
    },
    {
        date: "2025-03-12",
        version: "2.0.2",
        sections: [
            {
                label: "Application",
                items: [
                    "Inclut des corrections de bugs et des améliorations."
                ]
            }
        ]
    },
    {
        date: "2025-03-11",
        version: "2.0.1",
        sections: [
            {
                label: "Application",
                items: [
                    "Ajouter des colonnes supplémentaires à la liste des machines.",
                    "Ajouter la valeur 'Indéfini' aux filtres pour permettre leur recherche.",
                    "Implémenter les opérations CRUD (Créer, Lire, Mettre à jour, Supprimer) pour les roles."
                ]
            }
        ]
    },
    {
        date: "2025-03-01",
        version: "2.0.0",
        sections: [
            {
                label: "Application",
                items: [
                    "Ajouter des colonnes supplémentaires à la liste des machines.",
                    "Ajouter une fonctionnalité de tri pour la plupart des colonnes de la liste des machines.",
                    "Implémenter les opérations CRUD (Créer, Lire, Mettre à jour, Supprimer) pour les utilisateurs.",
                    "Permettre aux utilisateurs de changer leur mot de passe et de le récupérer via l'option 'Mot de passe oublié'."
                ]
            }
        ]
    },
    {
        date: "2024-12-17",
        version: "1.0.4",
        sections: [
            {
                label: "Application",
                items: [
                    "Possibilité d'ajouter une nouvelle marque.",
                    "Corriger le problème de perte des données de filtrage en cas de rafraîchissement.",
                    "Le champ de recherche permet désormais de rechercher par nom de machine, marque et autres champs de texte."
                ]
            }
        ]
    },
    {
        date: "2024-11-16",
        version: "1.0.3",
        sections: [
            {
                label: "Application",
                items: [
                    "Modifiez le nom de l'application en 'CDD Maintenance & Suivi'.",
                    "Mettez à jour la table des rôles et des identifiants avec les nouveaux paramètres d'identifiants.",
                    "Assurez-vous que les valeurs des filtres restent persistantes lors de la navigation vers la page de détails de la machine et du retour à la liste.",
                    "Si l'utilisateur ne voit qu'un seul Site, Pôle, Métier celui-ci est affiché comme un champ fixe qu'il ne peut pas modifier (ce n'est pas un filtre, juste une information affichée de manière fixe)."
                ]
            }
        ]
    },
    {
        date: "2024-11-13",
        version: "1.0.2",
        sections: [
            {
                label: "Application",
                items: [
                    "Ajouter des photos pour les Sites et les Pôles.",
                    "Mettre en œuvre des mises à jour du modèle de données pour Poles et Métier.",
                    "Ajouter 'Région' en tant que filtre et colonne dans la liste si j'ai accès à plus d'une région. Si je n'ai accès qu'à une seule région, le champ 'Région' doit être masqué."
                ]
            }
        ]
    },
    {
        date: "2024-10-24",
        version: "1.0.1",
        sections: [
            {
                label: "Application",
                items: [
                    "Les filtres affichent désormais uniquement les options disponibles (Marque, Métier, Type, etc.), simplifiant la sélection des données.",
                    "Vous pouvez désormais ajouter \"Marque\" (nom de la marque) lors de la mise à jour du champ Marque pour les machines, facilitant ainsi la gestion des détails des machines.",
                    "Ajout de champs modifiables pour \"Date contrôle\" et \"Date prochain contrôle\" dans la section \"Contrôle sécurité\" des machines pour un meilleur suivi des inspections de sécurité.",
                    "Lors de la modification d'une image de machine, vous pouvez désormais prendre une photo directement avec votre téléphone ou en choisir une dans votre bibliothèque, offrant plus d'options pour les mises à jour.",
                    "Marque",
                    "Date contrôle",
                    "Date prochain contrôle",
                    "Contrôle sécurité"
                ]
            }
        ]
    },
    {
        date: "2024-08-20",
        version: "1.0.0",
        sections: [
            {
                label: "Application",
                items: [
                    "Ajout des fonctionnalités de lecture, ajout, modification, suppression, et duplication pour les machines, offrant une gestion plus flexible et complète des données.",
                    "Ajout de la possibilité de filtrer les machines par sites, pôles, type, etc., facilitant ainsi la recherche et la gestion des données."
                ]
            }
        ]
    },

]
